/// <reference path="../../node_modules/@ms/office-online-strings/en-US/transcription-strings.d.ts" />

import * as React from 'react'
import { AppAuthenticationProviderContext } from './context';
import { Router, Route } from 'react-router'
import { createMemoryHistory } from 'history';
import { routes } from './routes';
import { Spinner, SpinnerType } from 'office-ui-fabric-react';
import { getLoadingSpinnerStyles } from './App.style';
import { InitializeApp } from './Boot';

export const App: React.FunctionComponent = (): JSX.Element => {
  const [ isAppLoaded, setIsAppLoaded] = React.useState(false);
  const [ authProvider, setAuthProvider ] = React.useState(null);

  const [ history, ] = React.useState(createMemoryHistory({
    initialEntries:routes.map(route => route.pathname),
    initialIndex: 0
  }));

  React.useEffect(() => {
    Office.onReady(() => {
      InitializeApp(history, setAuthProvider, setIsAppLoaded);
    });
  },
    // Passing an empty array ensures that the effect only runs once
    []
  );

  // Show spinner while app is not initialized
  if (!isAppLoaded) {
    const loadingSpinnerStyles = getLoadingSpinnerStyles();
    return (
      <div className={loadingSpinnerStyles.container}>
        <Spinner type={SpinnerType.large} />
      </div>
    );
  }

  return (
    <AppAuthenticationProviderContext.Provider value={authProvider}>
      <Router
        history={history}
      >
        { routes.map(route => 
          <Route
            key={route.name}
            path={route.pathname}
            component={route.component}
          />
        )}
      </Router>
    </AppAuthenticationProviderContext.Provider>
  );
};